import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=3e53ade4&scoped=true&lang=pug"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=3e53ade4&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=3e53ade4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e53ade4",
  null
  
)

export default component.exports